var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUVaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 36,
    viewBox: "0 0 166 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2874_8129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2202 7.70703L62.7151 35.2293H54.5874L44.0823 7.70703H51.9336L58.6238 26.9727L65.3691 7.70703H73.2202Z",
    fill: "#0B2443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.304 7.70723V35.2295H95.1721V31.9818C93.1816 34.4588 90.196 36.0002 86.1597 36.0002C78.8061 36.0002 72.7241 29.6701 72.7241 21.4684C72.7241 13.2667 78.8061 6.93652 86.1597 6.93652C90.196 6.93652 93.1816 8.47775 95.1721 10.9547V7.70725L102.304 7.70723ZM95.1721 21.4684C95.1721 16.8445 91.9099 13.7071 87.4868 13.7071C83.1189 13.7071 79.8567 16.8445 79.8567 21.4684C79.8567 26.0923 83.1189 29.2296 87.4868 29.2296C91.9099 29.2296 95.1721 26.092 95.1721 21.4684Z",
    fill: "#0B2443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.771 7.70703V35.2293H125.638V32.1469C123.979 34.6238 121.104 36 117.4 36C111.539 36 106.95 31.9267 106.95 24.6058V7.70703H114.083V23.7249C114.083 27.468 116.35 29.3945 119.556 29.3945C123.04 29.3945 125.638 27.3579 125.638 22.569V7.70703H132.771Z",
    fill: "#0B2443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.914 0H145.047V35.2293H137.914V0Z",
    fill: "#0B2443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.343 7.70703H0V23.1712C0 30.3989 5.05562 35.2293 12.6504 35.2293C20.2538 35.2293 25.2598 30.3989 25.2598 23.1712V7.70703H20.343ZM17.6381 18.7585C15.6601 18.7585 14.0566 17.1621 14.0566 15.193C14.0566 13.2238 15.6601 11.6275 17.6381 11.6275C19.6161 11.6275 21.2196 13.2238 21.2196 15.193C21.2196 17.1622 19.6161 18.7585 17.6381 18.7585Z",
    fill: "#0B2443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8625 17.0264H32.6614C31.3803 17.0264 30.2589 17.883 29.9273 19.1151L28.6523 23.8521H31.8536L33.1286 19.1151C33.4603 17.8832 34.5814 17.0266 35.8625 17.0264Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7486 17.0264H37.7551C36.4741 17.0266 35.353 17.8832 35.0213 19.1151L33.7463 23.8521H39.0129C40.2941 23.8521 41.4155 22.9954 41.747 21.7635L43.022 17.0264L41.7486 17.0264Z",
    fill: "#0B2443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.753 25.982V14.5316H161.868C163.149 14.5316 164.27 13.675 164.602 12.4432L165.876 7.70536H159.753V0L152.622 6.69175V7.70536L152.544 7.7418C150.754 7.95483 149.246 9.22766 148.77 10.9946L148.216 13.055L147.819 14.5316L152.622 14.5317V25.982C152.622 33.4148 155.995 36.329 166 35.2302V28.7907C161.912 29.0105 159.753 28.9534 159.753 25.982Z",
    fill: "#0B2443"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2874_8129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUVaultLogo);
export default __webpack_public_path__ + "static/media/u-vault-logo.1bff0b81d7327f311ecf873be733fbbb.svg";
export { ForwardRef as ReactComponent };